import fecha from 'fecha'

export function debounce (func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * url参数模板
 * eg:
 * urltemplate('/hello/:name', { name: 'janne' }) -> '/hello/janne'
 * @param {string} url url链接
 * @param {object} params 参数
 */
export function urltemplate (url, params) {
  if (!url) return url

  return url.replace(/:([a-z]+)/gi, function (match, p1) {
    const replacement = params[p1]

    if (!replacement) {
      throw new Error(`[${url}] Could not find url parameter ${p1} in passed params object`)
    }

    return replacement
  })
}

export const getDateRange = (days) => {
  const now = new Date()
  const index = 1
  const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
  const startTime = new Date(endTime.getFullYear(), endTime.getMonth(), endTime.getDate() - days + index, 0, 0, 0)

  return {
    startTime: startTime,
    endTime: endTime
  }
}

export const getTimestamp = (time, unit = 'ms') => {
  if (unit === 's') {
    return Math.round(new Date(time) / 1000)
  } else {
    return new Date(time).getTime()
  }
}

export function formatDate (time, format, unit = 's') {
  if (unit === 's') {
    time = time * 1000
  }

  return fecha.format(time, format)
}

export function validatePassword (value) {
  return /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z\d]{6,18}$/.test(value)
}

export function validateCellphone (value) {
  return /^1\d{10}$/.test(value)
}

const ArrayMap = Array.prototype.map
export function findImageIds (str) {
  const $div = document.createElement('div')
  $div.innerHTML = str
  const $images = $div.querySelectorAll('img')

  return ArrayMap.call($images, $item => {
    const matchs = $item.src.match(/(\d{16,16})/)
    if (matchs) return matchs[0]
  }).filter(id => !!id)
}

/**
 * 判断标题中是否包含关键词
 * @param {String} strA 标题
 * @param {String} strB 关键词
 */
export function includeKeyword (strA, strB) {
  // NOTE: 特殊处理，有个别关键词中含隐藏字符，会导致判断失败，这里把它替换为空
  const keyword = strB.replace('\ufeff', '')
  for (let i = 0; i < keyword.length; i++) {
    const term = keyword[i]
    if (term && strA.indexOf(term) === -1) {
      return false
    }
  }

  return true
}

/**
 * 格式化比率值
 */
export function formatRatio (value) {
  if (typeof value === 'number') {
    return Number((value * 100).toFixed(2)) + '%'
  } else {
    return '-'
  }
}
